import { Box, Grid, Typography, styled } from '@mui/material';
import React from 'react';
import { COMPANY_INFO } from '../../variables';
import { FooterTitles } from './Footer';

export const ContactUsContent = styled(Typography)(() => ({
  display: 'block',
}));

const ContactUs = () => {
  const {
    address: { street, zipCode, city },
    mobile,
    phone,
    fax,
    email,
  } = COMPANY_INFO;

  return (
    <Grid
      item
      xs={3}
    >
      <FooterTitles variant='h4'>Contacte-nos</FooterTitles>

      <ContactUsContent>
        {street} <br /> {zipCode}
        <br />
        {city}
      </ContactUsContent>

      {mobile.value && (
        <Box sx={{ marginTop: 1.5 }}>
          <ContactUsContent
            component={'a'}
            href={`tel:${mobile.value}`}
            title={mobile.label}
          >
            <strong>Tel. </strong>
            {mobile.label}
          </ContactUsContent>
          <Typography variant='xsmall'>
            (Chamada para a rede móvel nacional)
          </Typography>
        </Box>
      )}

      {phone.value && (
        <Box sx={{ marginTop: 1.5 }}>
          <ContactUsContent
            component={'a'}
            href={`tel:${phone.value}`}
            title={phone.label}
          >
            <strong>Telf. </strong>
            {phone.label}
          </ContactUsContent>
          <Typography variant='xsmall'>
            (Chamada para a rede fixa nacional)
          </Typography>
        </Box>
      )}

      {fax.value && (
        <ContactUsContent sx={{ marginTop: 1.5 }}>
          <strong>Fax. </strong>
          {fax.label}
        </ContactUsContent>
      )}

      {email && (
        <ContactUsContent
          component={'a'}
          href={`mailto:${email}`}
          title={email}
          sx={{
            marginTop: 1.5,
          }}
        >
          <strong>E. </strong>
          {email}
        </ContactUsContent>
      )}
    </Grid>
  );
};

export default ContactUs;
